import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader';
import LazyLoad from 'vanilla-lazyload';

if (typeof document !== 'undefined' && !document.lazyLoadInstance) {
	// Only initialize it one time for the entire application
	const lazyloadConfig = {
		threshold: 500,
		elements_selector: '.js-lazyLoad',
	};
	document.lazyLoadInstance = new LazyLoad(lazyloadConfig);
}

const LazyImage = ({ className = [], ...props }) => {
	useEffect(() => {
		document.lazyLoadInstance.update();
	});

	if (!Array.isArray(className)) className = [className];

	// All props should be returned from utils/image helper.
	return (
		<img className={[...className].join(' ')} {...props} />
	);
};

export default hot(module)(LazyImage);
